import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { ATLAS_InspectionConnectionReportSections } from "./ATLAS_InspectionConnectionReportSchema";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { getCustomer, SUPPORTED_CUSTOMERS } from "../../../MainPage/VersionInfo";
import { cnFraMasterKey } from "../../CN/cnFraMasterKeys";

const { rotorBlade,rotorBladeTable,driveTrain,driveTrainTable,supportStructure, supportStructureTable } = ATLAS_InspectionConnectionReportSections;
// driveTrain,supportStructure
const rotorBladeTestCodes = [
    "atlasRotorBladeVisualInspection",
    "atlasRotorBladeTorqueScrewConnections",
];
const driveTrainTestCodes = [
    "atlasDrivetrainTorqueScrewConnections",
    "atlasDrivetrainVisualInspection",
    "atlasDrivetrainLubricationInspection",
];


const supportStructureTestCodes = [
    "atlasSupportStructureVisualInspection",
    "atlasSupportStructureTorqueScrewConnections",
  ];




const masterKey = [
  { key: "OK", value: "Completed" },
  { key: "A/C", value: "Adjusted w/ Comments" },
  { key: "R/C", value: "Repaired / Replaced w/ Comments" },
  { key: "N/A", value: "Test Not Applicable" },
 
];

function getScrewTableData(data){
  const newTable=[]
  data.forEach(t=> { if(t.summary.tblBatt) { t.summary.tblBatt.forEach(trow=> newTable.push(trow))}})
  return newTable
}


const ReportView = (props) => {
  let { data } = props;
  const decodedData = Array.isArray(data.decodedData) ? data.decodedData : [];
  const rotorBladeData = decodedData.filter((t) => rotorBladeTestCodes.includes(t.testCode));
  const driveTrainData = decodedData.filter((t) => driveTrainTestCodes.includes(t.testCode));
  const supportStructureData = decodedData.filter((t) => supportStructureTestCodes.includes(t.testCode));

  let rotorBladeScrewTable= getScrewTableData(rotorBladeData)

  let driveTrainScrewTable= getScrewTableData(driveTrainData)

  let supportStructureScrewTable= getScrewTableData(supportStructureData)

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Visual Inspection and Screw Connections Report" {...props} fontSizeOverride={"35px"} />
      <span className="spacer"></span>
      <ReportFraInfoSectionContainer {...props} />
      <ReportFraConditionsMasterKey masterKey={getCustomer() === SUPPORTED_CUSTOMERS.CN ? cnFraMasterKey : masterKey} />
      <span className="spacer"></span>


      {/* //rotorBlade */}
      <table className="table-bordered" style={{ fontSize: "20px" }}>
         <ReportTableSectionRenderer section={rotorBlade} rowsData={rotorBladeData} /> 
         
      </table>
      {rotorBladeScrewTable.length >0}{

      <table className="table-bordered" style={{ fontSize: "20px" }}>
      <ReportTableSectionRenderer section={rotorBladeTable} rowsData={rotorBladeScrewTable} /> 

      </table>
      }

      {/* driveTrainTable */}
      <table className="table-bordered" style={{ fontSize: "20px" }}>
        <ReportTableSectionRenderer section={driveTrain} rowsData={driveTrainData} />
      </table>

      {driveTrainScrewTable.length >0}{

      <table className="table-bordered" style={{ fontSize: "20px" }}>
      <ReportTableSectionRenderer section={driveTrainTable} rowsData={driveTrainScrewTable} /> 

      </table>
      }

     {/* supportStructureTable */}
      <table className="table-bordered" style={{ fontSize: "20px" }}>
        <ReportTableSectionRenderer section={supportStructure} rowsData={supportStructureData} />
      </table>

      {supportStructureScrewTable.length >0}{

      <table className="table-bordered" style={{ fontSize: "20px" }}>
      <ReportTableSectionRenderer section={supportStructureTable} rowsData={supportStructureScrewTable} /> 

      </table>
      }
    </div>
  );
};

const ATLAS_InspectionConnectionReport = (props) => {
  const { reportData } = props;
 

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let reportGroups = ReportGroupingUtils.filterReportsByTestCodes(reportsByDateAndUser, [...rotorBladeTestCodes, ...driveTrainTestCodes,...supportStructureTestCodes]);
  let reportsWithDecodedFormData = ReportGroupingUtils.decodeTestsInReportGroups(reportGroups);

  return reportsWithDecodedFormData.map((report, i) => <ReportView key={i} {...props} data={report} />);
};

export default ATLAS_InspectionConnectionReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ATLAS/InspectionConnectionReport/index.jsx